import { jsxs as V, jsx as H } from "react/jsx-runtime";
import { forwardRef as $t, useId as At, useState as G, useRef as yt, useMemo as nt, useEffect as K } from "react";
import { c as N } from "./index.CWkFp9WS.js";
import { d as rt } from "./customParseFormat.VB0eI5Wm.js";
import { c as Tt, d as bt } from "./ODSDatePicker.utils.Dvmx0txe.js";
import { g as Mt, a as Ct, b as wt, r as T, F as y, D as ct, M as ot, Y as Nt } from "./date-time.BhxcicEx.js";
import { l as Rt } from "./floating-ui.react.MkaYL6o7.js";
import { O as Lt } from "./ODSColumn.B8Qu83P2.js";
import { O as it } from "./ODSRow.Du_e7gfN.js";
import { O as Yt } from "./ODSText.D6mgyggF.js";
import { O as Ht } from "./ODSButton.BmQliYzd.js";
import { O as _t } from "./ODSSupportMessage.DxN3bpZC.js";
import '../assets/ODSDatePickerInputField.css';const z = {
  D: "day",
  M: "month",
  Y: "year"
}, Q = (r) => {
  var t;
  return ((t = r.replace(/[DMY]/gi, "")) == null ? void 0 : t[0]) ?? "";
}, at = (r, t) => r === null || r <= 0 || !t ? !1 : t === "day" ? r <= ct : t === "month" ? r <= ot : t === "year" ? r <= Nt : !1, J = (r, t) => r === null || r < 0 || !t ? !1 : t === "day" ? r <= 3 : t === "month" ? r <= 1 : t === "year" ? r <= 999 : !1, st = (r, t, g) => {
  const s = Q(t), l = Mt(r, s).split(s);
  if (Ct(r, s).length > 0)
    return {
      text: g,
      partIndexToHighlight: l.length - 1
    };
  const m = g.split(s);
  let $ = -1, f = -1;
  const _ = t.split(s), c = _.map((D, o) => {
    const k = l.length > o ? l[o] : "", O = m.length > o ? m[o] : "", i = wt(
      D[0]
    );
    if (k === O) return k;
    if (!k) {
      if (O) {
        $ = o;
        const h = "0".repeat(D.length);
        if (O !== h)
          return f = o, h;
      }
      return f = o - 1, k;
    }
    const S = parseInt(T(k)), b = parseInt(
      T(O) ?? "0"
    ), F = O.indexOf(y) > -1 && b.toString().length < D.length;
    if ($ = o, S > 0) {
      if (F) {
        const A = parseInt(
          `${b % Math.pow(10, D.length - 1)}${S}`
        );
        return at(A, i) ? (f = o + 1, `${J(A, i) ? y : ""}${A.toString().padStart(D.length, "0")}`) : (f = o + 1, S.toString().padStart(D.length, "0"));
      }
      const h = J(S, i);
      return f = h ? o : o + 1, `${h ? y : ""}${S.toString().padStart(D.length, "0")}`;
    }
    if (S === 0) {
      if (f = o, F) {
        if (b > 0) {
          const h = parseInt(
            `${b % Math.pow(10, D.length - 1)}${S}`
          );
          if (at(h, i))
            return f = o + 1, `${J(
              h,
              i
            ) ? y : ""}${`${h}`.padStart(D.length, "0")}`;
        }
        return O;
      }
      return `${y}${"0".repeat(D.length)}`;
    }
    return "";
  });
  f = Math.max(
    0,
    Math.min(f, _.length - 1)
  );
  let R = c.filter(Boolean).join(s);
  const E = T(R);
  return f > $ && (E.length === t.indexOf(s) || E.length === t.lastIndexOf(s)) && (R += s), { text: R, partIndexToHighlight: f };
}, B = (r, t, g) => {
  const s = Q(g), x = t == null ? void 0 : t.indexOf(s), l = t == null ? void 0 : t.lastIndexOf(s), m = g.split(s);
  return x === -1 || r <= x ? {
    start: 0,
    end: x === -1 ? t.length : x,
    part: z[m[0].charAt(0)]
  } : l === -1 || r <= l ? {
    start: x + 1,
    end: l === -1 ? t.length : l,
    part: z[m[1].charAt(0)]
  } : {
    start: l + 1,
    end: t.length,
    part: z[m[2].charAt(0)]
  };
}, Et = (r, t) => r === "day" || r === "month" ? 1 : r === "year" ? t.year() : 0, jt = (r, t) => r === "day" ? ct : r === "month" ? ot : r === "year" ? t.year() : 0, Vt = $t(
  ({
    label: r,
    mode: t = "standard",
    disabled: g,
    supportMessageProps: s,
    className: x,
    size: l,
    value: m,
    placeholder: $,
    readOnly: f,
    id: _,
    format: c = "DD/MM/YYYY",
    selectDateAriaLabel: R = "Select date",
    changeDateAriaLabel: E = "Change date",
    disableCalendar: D = !1,
    onChange: o,
    onError: k,
    onValidationError: O,
    ...i
  }, S) => {
    const b = At(), F = _ ?? b, [h, A] = G(!1), [U, lt] = G("unfilled"), L = yt(null), j = nt(() => Q(c), [c]), {
      refs: ut,
      getReferenceProps: W,
      selectedDate: M,
      setSelectedDate: Z,
      disableFuture: dt,
      disablePast: ft,
      dateValidator: Dt,
      minDate: v,
      maxDate: tt,
      locale: ht
    } = Tt(), et = (n, e, a) => {
      if (!n) return "";
      if (typeof n == "string")
        return st(n, e, a).text;
      const d = rt(n);
      return d.isValid() ? d.format(e) : "";
    }, [u, X] = G(
      () => et(m, c, "")
    );
    K(() => {
      lt(u ? "filled" : $ || h ? "editing" : "unfilled");
    }, [h, u, $]);
    const pt = (n) => {
      var e;
      A(!0), (e = i == null ? void 0 : i.onFocus) == null || e.call(i, n);
    }, gt = (n) => {
      var e;
      u.indexOf(y) > -1 && q(T(u)), (e = i == null ? void 0 : i.onBlur) == null || e.call(i, n), A(!1);
    };
    K(() => {
      const n = et(m, c, "");
      X(n);
    }, [c, m]);
    const mt = (n) => {
      const { text: e, partIndexToHighlight: a } = st(
        n.target.value ?? "",
        c,
        u
      );
      q(e), setTimeout(() => {
        const d = e.indexOf(j) > -1 ? e.indexOf(j) : e.length, I = e.indexOf(j, d + 1) > -1 ? e.indexOf(j, d + 1) : e.length, P = a === 0 ? 0 : a === 1 ? d + 1 : I + 1, p = Math.max(
          P,
          a === 0 ? d : a === 1 ? I : e == null ? void 0 : e.length
        );
        Y(P, p);
      }, 10);
    }, q = (n) => {
      X(n);
      const e = rt(T(n), c, !0), { isValid: a, error: d } = bt(e, {
        precision: "date",
        disableFuture: dt,
        disablePast: ft,
        dateValidator: Dt,
        minDate: v,
        maxDate: tt
      }), I = e == null ? void 0 : e.toDate(), P = e.format(c);
      o && o(I, P, d), a ? Z(e) : (n == null ? void 0 : n.length) === c.length && (Z(void 0), k && k(I, P, d), O && O(P, d));
    };
    K(() => {
      X((n) => {
        if (!M && n) return n;
        const e = M ? M.format(c) : "";
        return M && n.indexOf(y) > -1 && e === T(n) ? n : e;
      });
    }, [M, c]);
    const It = (n) => n ? `${E} ${n.locale(ht).format("dddd, MMMM DD YYYY")}` : R, Ot = (n) => {
      var a;
      const e = (a = n.currentTarget) == null ? void 0 : a.selectionStart;
      if (e !== null) {
        const { start: d, end: I } = B(e, u, c);
        Y(d, I);
      }
    }, Y = (n, e) => {
      var a;
      L.current && ((a = L.current) == null || a.focus(), L.current.setSelectionRange(e, e), L.current.setSelectionRange(n, e));
    }, St = (n) => {
      const {
        start: e,
        end: a,
        part: d
      } = B(
        n.currentTarget.selectionStart ?? 0,
        u,
        c
      ), I = u == null ? void 0 : u.substring(e, a);
      if (!I) return !0;
      const P = n ? n == null ? void 0 : n.key : "";
      switch (P) {
        case "ArrowUp":
        case "ArrowDown": {
          const p = parseInt(
            T(I.toString()) ?? ""
          );
          if (isNaN(p)) return !0;
          const C = Et(d, v), w = jt(d, tt), xt = P === "ArrowUp" ? p + 1 > w ? C : p + 1 : p - 1 < C ? w : p - 1, kt = [
            u.slice(0, e),
            `${xt}`.padStart(2, "0"),
            u.slice(a)
          ].join("");
          return q(kt), setTimeout(() => {
            Y(e, a);
          }, 0), !1;
        }
        case "ArrowLeft": {
          const p = Math.max(0, e - 1);
          setTimeout(() => {
            const { start: C, end: w } = B(
              p,
              u,
              c
            );
            Y(C, w);
          }, 0);
          break;
        }
        case "ArrowRight": {
          const p = Math.min(u.length - 1, a + 1);
          setTimeout(() => {
            const { start: C, end: w } = B(
              p,
              u,
              c
            );
            Y(C, w);
          }, 0);
          break;
        }
      }
      return !0;
    }, Ft = (n) => {
      n.preventDefault();
    }, Pt = nt(
      () => W(),
      [W]
    );
    return /* @__PURE__ */ V(
      Lt,
      {
        as: "div",
        className: N(
          "ODSDatePickerInputField",
          `ODSDatePickerInputField--status-${U}`,
          `ODSDatePickerInputField--mode-${t}`,
          x
        ),
        children: [
          /* @__PURE__ */ V(
            it,
            {
              className: N(
                "ODSDatePickerInputField-Content",
                `ODSDatePickerInputField-Content--size-${l}`
              ),
              children: [
                /* @__PURE__ */ V(
                  Yt,
                  {
                    as: "label",
                    className: N(
                      "ODSDatePickerInputField-Label",
                      `ODSDatePickerInputField-Label--size-${l}`,
                      `ODSDatePickerInputField-Label--status-${U}`,
                      `ODSDatePickerInputField-Label--mode-${t}`,
                      { "ODSDatePickerInputField-Label--disabled": g }
                    ),
                    htmlFor: F,
                    children: [
                      r,
                      i.required ? /* @__PURE__ */ H("span", { className: "ODSDatepicker-Required", children: " * " }) : ""
                    ]
                  }
                ),
                /* @__PURE__ */ H(
                  "input",
                  {
                    ...i,
                    id: F,
                    ref: Rt([S, L]),
                    disabled: g,
                    type: "text",
                    inputMode: "numeric",
                    placeholder: $,
                    readOnly: f,
                    "aria-label": r,
                    className: N(
                      "ODSDatePickerInputField-InputField",
                      `ODSDatePickerInputField-InputField--status-${U}`,
                      `ODSDatePickerInputField-InputField--size-${l}`,
                      `ODSDatePickerInputField-InputField--mode-${t}`,
                      { "ODSDatePickerInputField-InputField--readonly": f },
                      { "ODSDatePickerInputField-InputField--disabled": g }
                    ),
                    onBlur: gt,
                    onFocus: pt,
                    "aria-invalid": t === "error",
                    "aria-describedby": (t === "informative" || t === "error") && (s != null && s.helperText) ? `${F}-support-message` : `${F}-description`,
                    ...i,
                    value: u,
                    onChange: mt,
                    onClick: Ot,
                    onKeyDown: St,
                    onPaste: Ft,
                    autoComplete: "off"
                  }
                ),
                /* @__PURE__ */ V("span", { id: `${F}-description`, className: "sr-only", children: [
                  "(format: ",
                  c,
                  ")"
                ] }),
                /* @__PURE__ */ H(
                  Ht,
                  {
                    className: N(
                      "ODSDatePickerInputField-CalendarAction",
                      `ODSDatePickerInputField-CalendarAction--size-${l}`,
                      `ODSDatePickerInputField-CalendarAction--mode-${t}`,
                      {
                        "ODSDatePickerInputField-CalendarAction--disableCalendar": D
                      }
                    ),
                    buttonIcon: "calendar-type-standard",
                    buttonType: "iconOnly",
                    size: l,
                    variant: "ghost",
                    disabled: g || f,
                    ref: ut.setReference,
                    "aria-label": It(M),
                    ...Pt
                  }
                )
              ]
            }
          ),
          (t === "informative" || t === "error") && /* @__PURE__ */ H(
            it,
            {
              id: `${F}-support-message`,
              className: N(
                "ODSDatePickerInputField-SupportText",
                `ODSDatePickerInputField-SupportText--size-${l}`
              ),
              children: /* @__PURE__ */ H(
                _t,
                {
                  className: "ODSDatePickerInputField-OdsSupportMessage",
                  helperText: "Message",
                  ...s,
                  mode: t
                }
              )
            }
          )
        ]
      }
    );
  }
);
Vt.displayName = "ODSDatePickerInputField";
export {
  Vt as O
};
//# sourceMappingURL=ODSDatePickerInputField.Dy4aEyJk.js.map
